import { configureStore, combineReducers } from '@reduxjs/toolkit';

// Store slices
import admin2EstimatesSlice from './slices/admin2EstimatesSlice';
import admin2ToolsSlice from './slices/admin2ToolsSlice';
import mapSlice from './slices/mapSlice';
import sidebarMapFiltersSlice from './slices/sidebarMapFiltersSlice';

// Store query
import { api } from './query/getDataRtkQuery';

const rootReducer = combineReducers({
  admin2EstimatesSlice,
  admin2ToolsSlice,
  mapSlice,
  sidebarMapFiltersSlice,
  [api.reducerPath]: api.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    // line below enables caching functionality
    getDefaultMiddleware().concat(api.middleware),
});
